import { Avatar, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../image/boozLogo.png";
import { authResetState, registerRequest } from "../../redux/auth/AuthAction";
import "../../style/register.css";
import { StyledBox, StyledContainer, styles } from "../components/LoginStyles";
import CustomButton from "../constant/commonButton";
import ReusableFormFields from "../constant/reusableFormFields";
import { APP_LINK } from "../global/MenuItems";
import { mapBackendMessage } from "../notification/BackendMessage";
import CommonDialog from "../notification/ErrorDialogbox";
import { APP_LINKS } from "../global/wholeSalerMenuItems";
import CryptoJS from "crypto-js";

export default function Register() {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [dialogMessage, setDialogMessage] = useState("");
  const [showPasswordRequirements, setShowPasswordRequirements] =
    useState(false);
  const dispatch = useDispatch();
  const form = useForm();
  const { register, handleSubmit, formState, control, reset, setError } = form;
  const { errors } = formState;
  const registerState = useSelector((state) => state?.auth?.newUser || {});

  // Password validation function
  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
      password
    );

    if (password.length < minLength) {
      return `Password must be at least ${minLength} characters long`;
    }
    if (!hasUpperCase) {
      return "Password must contain at least 1 uppercase letter";
    }
    if (!hasNumber) {
      return "Password must contain at least 1 number";
    }
    if (!hasSpecialChar) {
      return "Password must contain at least 1 special character";
    }
    return true;
  };

  const handleFieldFocus = (fieldName, e) => {
    if (fieldName === "password") {
      setShowPasswordRequirements(true);
    } else {
      setShowPasswordRequirements(false);
    }
  };

  const handleFieldBlur = (fieldName, event) => {
    if (fieldName === "password") {
      setShowPasswordRequirements(false);
    }
  };

  const inputFields = [
    {
      name: "name",
      label: "Company Name",
      rules: { required: "Name is required" },
    },
    {
      name: "license_no",
      label: "License No",
      rules: {
        required: "License No is required",
        pattern: {
          value: /^[a-zA-Z0-9-]{5,15}$/,
          message:
            "License No must be 5-15 characters (letters, numbers, hyphens).",
        },
      },
    },
    {
      name: "tax_id",
      label: "Tax ID",
      rules: {
        required: "Tax ID is required",
        pattern: {
          value: /^[0-9]{9,12}$/,
          message: "Tax ID must be 9-12 digits and contain numbers only.",
        },
      },
    },
    {
      name: "company_reg_no",
      label: "Company Reg No",
      rules: {
        required: "Company Reg No is required",
        pattern: {
          value: /^[A-Z0-9]{8,12}$/,
          message: "Company Reg No must be 8-12 uppercase letters or numbers.",
        },
      },
    },
    {
      name: "first_name",
      label: "First Name",
      rules: { required: "First Name is required" },
    },
    {
      name: "last_name",
      label: "Last Name",
      rules: { required: "Last Name is required" },
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      rules: {
        required: "Password is required",
        validate: validatePassword,
      },
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
      rules: { required: "Address is required" },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{10}$/,
          message: "Phone number must be exactly 10 digits",
        },
      },
    },
    {
      name: "user_type",
      label: "User  Type",
      defaultValue: "3",
      rules: { required: "User  Type is required" },
      display: false,
    },
  ];

  useEffect(() => {
    if (registerState?.error) {
      const errorFields = registerState?.errorFields || {};
      const message = registerState?.message?.trim() || "";
      const error = registerState?.error?.toLowerCase() || "";

      console.log("errorFields:", errorFields);
      console.log("message:", message);

      if (error.includes("contact already exists")) {
        setError("contact", {
          type: "manual",
          message: "This phone number is already registered.",
        });
      } else if (Object.keys(errorFields).length > 0) {
        Object.entries(errorFields).forEach(([field, fieldMsg]) => {
          const fullMessage = fieldMsg ? `${fieldMsg} - ${message}` : message;
          setError(field, {
            type: "manual",
            message: fullMessage,
          });
        });
      } else if (
        message.toLowerCase().includes("email") &&
        (message.toLowerCase().includes("already") ||
          message.toLowerCase().includes("registered") ||
          message.toLowerCase().includes("exists"))
      ) {
        setError("email", {
          type: "manual",
          message: "This email is already registered.",
        });
      } else if (message.includes("column 'contact'")) {
        setError("contact", {
          type: "manual",
          message: "Phone number is too long. Please enter a valid number.",
        });
      } else {
        const customMessage = mapBackendMessage(
          registerState?.errormessage ||
            "An error occurred while adding details."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
      }
      dispatch(authResetState());
    } else if (registerState?.success) {
      setDialogMessage("Registered successfully");
      setIsSuccess(true);
      setDialogOpen(true);
      navigate(APP_LINKS.OTPVERIFYREGISTER);
      dispatch(authResetState());
    }
  }, [registerState, navigate, setError]);

  useEffect(() => {
    return () => {
      dispatch(authResetState());
    };
  }, []);

  const SECRET_KEY = "843567893696976453275974432697R634976";

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
  };

  const onSubmit = (data) => {
    const normalizeText = (text) => (text ? text.replace(/\s+/g, "") : "");

    if (data?.email) {
      const encryptedEmail = encryptData(data.email);
      localStorage.setItem("email", encryptedEmail);
    }

    if (data?.contact) {
      const encryptedPhone = encryptData(data.contact);
      localStorage.setItem("phone", encryptedPhone);
    }
    const formdata = {
      ...data,
      salt: "",
      tax_id: normalizeText(data?.tax_id),
      company_reg_no: normalizeText(data?.company_reg_no),
      license_no: normalizeText(data?.license_no),
    };
    dispatch(registerRequest(formdata));
  };

  const handlelogin = () => {
    navigate(APP_LINK.LOGIN);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    if (isSuccess) {
      reset();
    }
  };

  return (
    <StyledBox>
      <StyledContainer maxWidth="xs">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} className="login-page">
            <Grid item xs={12} align="center">
              <Avatar src={Logo} className="avatar" />
            </Grid>
            <Grid item xs={12} textAlign={"center"}>
              <Typography
                variant="p"
                align="center"
                fontWeight={600}
                gutterBottom
              >
                Register Now
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ReusableFormFields
                inputFields={inputFields}
                control={control}
                errors={errors}
                required={true}
                register={register}
                onFieldFocus={handleFieldFocus}
                onFieldBlur={handleFieldBlur}
              />

              {/* Password Requirements - Show only when password field is focused */}
              {showPasswordRequirements && (
                <Box sx={styles.signupShowPassword}>
                  <Typography
                    variant="body2"
                    sx={styles.signupShowPasswordTypo}
                  >
                    Password Requirements:
                  </Typography>
                  <Typography
                    variant="body2"
                    component="ul"
                    sx={styles.signupShowPasswordBody}
                  >
                    <li>Minimum 8 characters</li>
                    <li>At least 1 uppercase letter (A-Z)</li>
                    <li>At least 1 number (0-9)</li>
                    <li>At least 1 special character (!@#$%^&*)</li>
                  </Typography>
                </Box>
              )}
            </Grid>

            <Grid item xs={12}>
              <CustomButton
                text="Submit"
                size="large"
                type="submit"
                buttonStyle="StyledButton"
                disabled={registerState?.inProgress}
                loading={registerState?.inProgress}
              />
            </Grid>
            <Grid item xs={12} align="center">
              <Typography variant="body2" align="center" gutterBottom>
                - - - - - - - - - - or - - - - - - - - - -
              </Typography>
              <Link to="/" style={styles.loginDirectly}>
                <Typography
                  variant="h4"
                  align="center"
                  padding="8px"
                  gutterBottom
                  onClick={handlelogin}
                >
                  ← Back To Login
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </form>
        <CommonDialog
          open={dialogOpen}
          isSuccess={isSuccess}
          onClose={handleDialogClose}
          messageSuccess={dialogMessage}
          messageError={dialogMessage}
        />
      </StyledContainer>
    </StyledBox>
  );
}
